"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disablePhoneResendVerification = void 0;
const disablePhoneResendVerification = setDisabledResend => {
  setDisabledResend(true);
  setTimeout(() => {
    setDisabledResend(false);
  }, 60000);
};
exports.disablePhoneResendVerification = disablePhoneResendVerification;
//# sourceMappingURL=disabledPhoneVerification.js.map